import React, {useContext, useEffect, useState} from "react";
import {Row} from "antd";
import {ArrowsAltOutlined, ShrinkOutlined} from "@ant-design/icons";
import GoogleMapReact from "google-map-react";
import {MapContainer, MapTools} from "./DeliveryRequestMap.styles";
import {useTranslation} from "react-i18next";
import apiKey from "../../../_core/apiKey";
import {CreateDeliveryContext} from "../CreateDeliveryRequest";

export const DeliveryRequestMap = () => {
    const {i18n} = useTranslation([]);
    const defaultCenter = {lat: 41.0, lng: 29};
    const defaultZoom = 10;
    const [map, setMap] = useState();
    const [maps, setMaps] = useState();
    const [mapMode, setMapMode] = useState("relative");
    const [markersRef, setMarkersRef] = useState([]);

    const {markerList = [], updateOrder, reverseGeocode, handleMapClick} = useContext(
        CreateDeliveryContext
    );

    const toggleMapMode = e => {
        if (mapMode == "fixed") {
            setMapMode("relative");
        } else {
            setMapMode("fixed");
        }
        e.currentTarget.blur();
    };

    const fitBounds = ({map, locations}) => {
        if (!map) return;

        const bounds = new window.google.maps.LatLngBounds();
        if (locations) {
            locations.forEach(location => {
                boundsExtender({
                    bounds,
                    lat: location?.latitude,
                    lng: location?.longitude
                });
            });
        }

        if (bounds.isEmpty()) return;

        map.fitBounds(bounds);
        if (locations.length === 1) {
            map.setZoom(map.getZoom() - 5);
        }
    };

    const boundsExtender = ({bounds, lat, lng}) => {
        if (lat === undefined || lng === undefined) return;
        bounds.extend({lat, lng});
    };

    const handleEsc = event => {
        if (event.keyCode === 27 && mapMode == "fixed") {
            setMapMode("relative");
        }
    };

    const onGoogleApiLoaded = ({map, maps}) => {
        setMap(map);
        setMaps(maps);
        fitBounds({
            map,
            locations: markerList.map(marker => marker.location)
        });
    };

    useEffect(() => {
        if (map && maps && markerList.length > 0) {
            markersRef.forEach(marker => marker.setMap(null));

            const newMarkers = markerList.map((markerData, index) => {
                const isPickupPoint = markerData.color === "red";
                const isDeliveryPoint = markerData.color === "gray";

                const marker = new maps.Marker({
                    position: {
                        lat: markerData.location.latitude,
                        lng: markerData.location.longitude
                    },
                    map: map,
                    draggable: isDeliveryPoint,
                    title: isPickupPoint
                        ? "Alış Noktası"
                        : "Teslimat Noktası - Sürükleyerek Konumu Değiştirebilirsiniz",
                    icon: {
                        path: maps.SymbolPath.CIRCLE,
                        scale: 15,
                        fillColor: markerData.color === "red" ? "#ff4d4f" : "gray",
                        fillOpacity: 1,
                        strokeColor: "#ffffff",
                        strokeWeight: 2
                    },
                    label: {
                        text: markerData.title,
                        color: "white",
                        fontSize: "12px",
                        fontWeight: "bold"
                    }
                });

                // Add drag event listener only for delivery points
                if (isDeliveryPoint) {
                    marker.addListener("dragend", async event => {
                        const lat = event.latLng.lat();
                        const lng = event.latLng.lng();

                        // Find the order index from marker title (title format: "3", "4", etc.)
                        const orderIndex = parseInt(markerData.title) - 2; // -2 because pickup is 1, orders start from 2

                        if (orderIndex >= 0 && reverseGeocode) {
                            try {
                                const address = await reverseGeocode(lat, lng);
                                updateOrder({
                                    orderIndex: orderIndex,
                                    order: {
                                        receiverLocation: {lat, lon: lng},
                                        receiverAddress: address
                                    }
                                });
                            } catch (error) {
                                console.error("Reverse geocoding failed:", error);
                                updateOrder({
                                    orderIndex: orderIndex,
                                    order: {
                                        receiverLocation: {lat, lon: lng}
                                    }
                                });
                            }
                        }
                    });
                }

                return marker;
            });

            setMarkersRef(newMarkers);
        }
    }, [map, maps, markerList]);

    useEffect(() => {
        if (map && maps) {
            fitBounds({
                map,
                locations: markerList.map(marker => marker.location)
            });
        }
    }, [markerList]);
    useEffect(() => {
        window.addEventListener("keydown", handleEsc);
        return () => {
            window.removeEventListener("keydown", handleEsc);
        };
    }, [mapMode]);

    return (
        <Row gutter={[0, 30]} style={{height: "100%"}}>
            <MapContainer mode={mapMode} data-testid="map">
                <MapTools onClick={toggleMapMode}>
                    {mapMode == "relative" ? <ArrowsAltOutlined /> : <ShrinkOutlined />}
                </MapTools>
                <GoogleMapReact
                    onGoogleApiLoaded={onGoogleApiLoaded}
                    heatmapLibrary={true}
                    center={defaultCenter}
                    bootstrapURLKeys={{
                        key: apiKey,
                        language: i18n.resolvedLanguage || "tr"
                    }}
                    yesIWantToUseGoogleMapApiInternals
                    defaultZoom={defaultZoom}
                    options={{
                        fullscreenControl: false,
                        gestureHandling: "greedy"
                    }}
                    onClick={handleMapClick}
                ></GoogleMapReact>
            </MapContainer>
        </Row>
    );
};
